import { render, staticRenderFns } from "./PageControl.vue?vue&type=template&id=47346c97&"
import script from "./PageControl.vue?vue&type=script&lang=js&"
export * from "./PageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports